<template>
  <QBtn
    class="sai-btn"
    v-on="$listeners"
    v-bind="$attrs"
    :rounded="rounded"
    :size="size"
    :padding="padding"
    :ripple="ripple"
    :color="color"
    :unelevated="unelevated"
    :style="borderWidthCSSVariable"
  >
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
  </QBtn>
</template>

<script>
import { QBtn } from 'quasar';

export default {
  name: 'SAIBtn',
  props: {
    color: {
      default: 'primary'
    },
    size: {
      type: String,
      default: 'md'
    },
    ripple: Boolean,
    rounded: {
      type: Boolean,
      default: true
    },
    unelevated: {
      type: Boolean,
      default: true
    },
    padding: {
      type: String,
      default: 'sm lg'
    },
    borderWidth: {
      type: String,
      default: '2px'
    }
  },
  computed: {
    borderWidthCSSVariable() {
      return {
        '--border-width': this.borderWidth
      };
    }
  },
  components: { QBtn }
};
</script>

<style lang="sass" scoped>
.sai-btn::v-deep
  opacity: 1 !important

  &.disabled:not(.bg-primary):not(.bg-application-primary)
    background: $grey-3 !important
    color: $grey-6 !important

  &.disabled
    background: $grey-3 !important
    color: $grey-6 !important

  &.q-btn--outline .q-btn__wrapper:before
    border-width: var(--border-width)
</style>
